import type Store from '@ember-data/store';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
import type { ModelSchema } from 'ember-data';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
import type { ModelRegistry } from 'ember-data/model';
import ApplicationSerializer from 'garaje/serializers/application';

interface FieldSettingApiItem {
  sign_in_field_id: number | null;
  data_category: string | null;
  display_name: string;
  is_selected: boolean;
}

interface FieldSettingApiResponse {
  field_settings: FieldSettingApiItem[];
}

export default class FieldSettingSerializer extends ApplicationSerializer {
  normalizeFindHasManyResponse(
    store: Store,
    primaryModelClass: ModelSchema<keyof ModelRegistry>,
    payload: FieldSettingApiResponse,
    id: string | number,
    requestType: string,
  ): ReturnType<ApplicationSerializer['normalizeFindHasManyResponse']> {
    const jsonApiPayload = {
      data: payload.field_settings.map((item) => ({
        type: 'field-settings',
        id: `flow:${id}:${item.sign_in_field_id !== null ? String(item.sign_in_field_id) : item.data_category}`,
        attributes: {
          'sign-in-field-id': item.sign_in_field_id,
          'data-category': item.data_category,
          'display-name': item.display_name,
          'is-selected': item.is_selected,
        },
      })),
    };

    return super.normalizeFindHasManyResponse(store, primaryModelClass, jsonApiPayload, id, requestType);
  }
}
